import './loader.css';
import { config, AnimationMap } from './animations';
import {
  CONTAINER_CLASSNAME,
  isEmmaApp,
  LOADER_STATE_CHANGE_EVT,
} from './constants';
import { LoaderState } from './types';
import { createObserver } from './controller';

const spinnerSvg =
  '<svg xmlns="http://www.w3.org/2000/svg" width="42px" height="42px" fill="#494DF4" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100"><rect width="5" height="21" x="47.5" y="4.5" rx="2.3" ry="2.3"><animate attributeName="opacity" begin="-0.9s" dur="1s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/></rect><rect width="5" height="21" x="47.5" y="4.5" rx="2.3" ry="2.3" transform="rotate(36 50 50)"><animate attributeName="opacity" begin="-0.8s" dur="1s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/></rect><rect width="5" height="21" x="47.5" y="4.5" rx="2.3" ry="2.3" transform="rotate(72 50 50)"><animate attributeName="opacity" begin="-0.7s" dur="1s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/></rect><rect width="5" height="21" x="47.5" y="4.5" rx="2.3" ry="2.3" transform="rotate(108 50 50)"><animate attributeName="opacity" begin="-0.6s" dur="1s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/></rect><rect width="5" height="21" x="47.5" y="4.5" rx="2.3" ry="2.3" transform="rotate(144 50 50)"><animate attributeName="opacity" begin="-0.5s" dur="1s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/></rect><rect width="5" height="21" x="47.5" y="4.5" rx="2.3" ry="2.3" transform="rotate(180 50 50)"><animate attributeName="opacity" begin="-0.4s" dur="1s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/></rect><rect width="5" height="21" x="47.5" y="4.5" rx="2.3" ry="2.3" transform="rotate(216 50 50)"><animate attributeName="opacity" begin="-0.3s" dur="1s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/></rect><rect width="5" height="21" x="47.5" y="4.5" rx="2.3" ry="2.3" transform="rotate(252 50 50)"><animate attributeName="opacity" begin="-0.2s" dur="1s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/></rect><rect width="5" height="21" x="47.5" y="4.5" rx="2.3" ry="2.3" transform="rotate(288 50 50)"><animate attributeName="opacity" begin="-0.1s" dur="1s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/></rect><rect width="5" height="21" x="47.5" y="4.5" rx="2.3" ry="2.3" transform="rotate(324 50 50)"><animate attributeName="opacity" begin="0s" dur="1s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/></rect></svg>';

let tmp: HTMLDivElement;

const getDiv = () => {
  if (tmp) return tmp;

  const c = document.createElement('div');
  c.className = CONTAINER_CLASSNAME;
  c.style.display = 'none';

  tmp = c;

  return tmp;
};

export const renderSpinner = (targetNode: HTMLElement) => {
  const c = getDiv();
  c.innerHTML = spinnerSvg;
  targetNode.appendChild(c);
  return c;
};

export const renderLottie = async (
  targetNode: HTMLElement,
  key: keyof AnimationMap = 'DefaultLoader',
) => {
  const svgContainer = document.createElement('div');
  const c = getDiv();
  c.innerHTML = '';
  c.appendChild(svgContainer);
  targetNode.appendChild(c);

  // @ts-ignore
  window.bodymovin?.loadAnimation?.({
    wrapper: svgContainer,
    animType: 'svg',
    loop: true,
    animationData: await config[key],
  });

  return c;
};

const handler = (e: CustomEvent<LoaderState>) => {
  if (isEmmaApp()) return;

  const c = getDiv();

  const state = e.detail;
  const targetNode = state.currentTarget;
  if (!state.show) {
    c.style.display = 'none';
    return;
  }

  if (!targetNode) return;

  if (state.content === 'spinner') {
    renderSpinner(targetNode);
    c.style.display = '';
  } else {
    renderLottie(targetNode, state.content);
    c.style.display = '';
  }
};

const observer = createObserver();

export const listen = () => {
  observer.listen();
  window.addEventListener(LOADER_STATE_CHANGE_EVT, handler);
};

export const unlisten = () => {
  observer.stop();
  window.removeEventListener(LOADER_STATE_CHANGE_EVT, handler);
};
